export default "#### Can’t decide yet?\n\nProceed with the checkout and one of our finance specialists will contact you to find a quote that suits.\n";